import { useEffect, useRef, useState } from "react";
import logo from "./assets/ll.png";
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  onAuthStateChanged,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { app } from "../Admin/Config/Config";
import { useAuth } from "./AuthContext";
import { getFunctions, httpsCallable } from "firebase/functions";
import { countryCodes } from "./assets/Countrycodes";


export default function Login() {
  const provider = new GoogleAuthProvider();
  const { showLoginPopup, triggerLoginPopup } = useAuth();
  const auth = getAuth(app);
  const recaptchaVerifierRef = useRef(null);
  const [isSignUp, setIsSignUp] = useState(false);
  const [authMethod, setAuthMethod] = useState("email");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [Confirmationresult, setConfirmationResult] = useState(null);
  const [phoneLoading, setPhoneLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    countryCode: "91",
  });
  const [phoneLogin, setPhoneLogin] = useState({
    phone: "",
    otp: ["", "", "", "", "", ""],
    showOtp: false,
    countryCode: "+91",
  });

  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "success",
  });


  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        triggerLoginPopup(false);
      }
    });
  }, [auth, triggerLoginPopup]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && showLoginPopup) {
        triggerLoginPopup(false);
      }
    };

    if (showLoginPopup) {
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [showLoginPopup, triggerLoginPopup]);

  // ================================ Phone Authentication =============================== //
  const [otpError, setOtpError] = useState("");
  const handleAuthAccountCheck = async(e) => {
    e.preventDefault();
    setPhoneLoading(true);
    const rawPhone = `${phoneLogin.countryCode}${phoneLogin.phone}`;
    const phoneWithCode = rawPhone.startsWith('+')
      ? rawPhone
      : `+${rawPhone}`;
    const functions = getFunctions(app, "asia-south1");
    const checkAccountUser = httpsCallable(functions, "checkAccountUser");
    try {
      console.log("Phone with code:", phoneWithCode);
      const result = await checkAccountUser({ mobile: phoneWithCode });
      console.log("Result:", result.data);
      if (result.data.code === 200) {
        setOtpError("");
        setupInvisibleRecaptcha(phoneWithCode);

      } else if (result.data.code === 404) {
        setPhoneLoading(false);
        setOtpError("Account does not exist. Please sign up using email or use Google signIn");
        showToast("Account does not exist. Please sign up using email or use Google signIn", "error");
      } else {
        setPhoneLoading(false);
        console.log("Error calling function:", result.data);
        showToast("Validation failed. Please check the number", "error");
      }
    } catch (err) {
      console.log("Error calling function:", err.message);
    }
  }

  useEffect(() => {
    return () => {
      reCaptchaCleanup();
    };
  }, []);
  const reCaptchaCleanup = () => {
    if (recaptchaVerifierRef.current) {
      recaptchaVerifierRef.current.clear();
      recaptchaVerifierRef.current = null;
    }
  }

  const setupInvisibleRecaptcha = async (phone) => {
    // const phoneRegex = /^\+91[0-9]{10}$/;
    // if (!phone || !phoneRegex.test(phone)) {
    //   showToast("Invalid phone number", "error");
    //   setPhoneLoading(false);
    //   return;
    // }

    try {
      if (!recaptchaVerifierRef.current) {
        recaptchaVerifierRef.current = new RecaptchaVerifier(
          "recaptcha-container",
          {
            size: "invisible",
            callback: (response) => {
              // console.log("reCAPTCHA verified:", response);
            },
            "expired-callback": () => {
              setPhoneLoading(false);
              reCaptchaCleanup();
              showToast("Session expired! Please try again", "error");
            },
            "error-callback": (error) => {
              console.error("reCAPTCHA error:", error);
              setPhoneLoading(false);
              reCaptchaCleanup();
              showToast("verification failed! Please try again", "error");
            },
          },
          auth
        );
      }
      await recaptchaVerifierRef.current.render().catch((err) => {
        setPhoneLoading(false);
        reCaptchaCleanup();
      });

      const appVerifier = recaptchaVerifierRef.current;
      const result = await signInWithPhoneNumber(
        auth,
        phone,
        appVerifier
      );
      setConfirmationResult(result);
      setPhoneLogin((prev) => ({ ...prev, showOtp: true }));
      showToast("OTP sent to your phone!", "success");
    } catch (error) {
      console.error("Phone auth error:", error.code, error.message);
      let errorMessage = "Something went wrong. Please try again.";
      switch (error.code) {
        case "auth/invalid-app-credential":
          errorMessage =
            "Invalid reCAPTCHA credential. Ensure reCAPTCHA v3 is configured in Firebase App Check and localhost:3001 is whitelisted.";
          break;
        case "auth/invalid-phone-number":
          errorMessage = "Invalid phone number format.";
          break;
        case "auth/too-many-requests":
          errorMessage = "Too many attempts. Please try again later.";
          break;
        case "auth/quota-exceeded":
          errorMessage = "SMS quota exceeded. Try again later.";
          break;
        default:
          errorMessage = `Error: ${error.message}`;
      }
      setPhoneLoading(false);
      reCaptchaCleanup();
      showToast(errorMessage, "error");
    }
  };
// ============== Resend OTP Timer ============== //


const [resendTimer, setResendTimer] = useState(0);
const timerRef = useRef(null);
useEffect(() => {
  if (phoneLogin.showOtp && resendTimer === 0) {
    setResendTimer(120);
  }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [phoneLogin.showOtp]);

useEffect(() => {
  if (resendTimer > 0) {
    timerRef.current = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
  }
  return () => clearTimeout(timerRef.current);
}, [resendTimer]);


// ============== Timer Ends Here ============== //
  const handleResendOtp = async () => {
    if (resendTimer > 0) return;
    const phone = phoneLogin.countryCode + phoneLogin.phone;
    setPhoneLogin((prev) => ({ ...prev, otp: ["", "", "", "", "", ""] }));
    if (!recaptchaVerifierRef.current) {
      showToast("reCAPTCHA not initialized", "error");
      return;
    }
    try {
      const result = await signInWithPhoneNumber(
        auth,
        phone,
        recaptchaVerifierRef.current
      );
      setConfirmationResult(result);
      showToast("OTP resent successfully!", "success");
    } catch (error) {
      console.error("Resend OTP error:", error.code, error.message);
      let errorMessage = "Failed to resend OTP. Please try again.";
      switch (error.code) {
        case "auth/invalid-app-credential":
          errorMessage =
            `Error code: ${error.code} - Please contact the admin for further assistance.`;
          break;
        case "auth/too-many-requests":
          errorMessage = "Too many attempts. Please try again later.";
          break;
        default:
          errorMessage = `Error: ${error.code} - Please contact the admin for further assistance.`;
      }
      showToast(errorMessage, "error");
      if (recaptchaVerifierRef.current) {
        recaptchaVerifierRef.current.clear();
        recaptchaVerifierRef.current = null;
      }
    }
  };

  const handleOtpChange = (index, value) => {
    if (value.length <= 1 && /^[0-9]*$/.test(value)) {
      const newOtp = [...phoneLogin.otp];
      newOtp[index] = value;
      setPhoneLogin((prev) => ({
        ...prev,
        otp: newOtp,
      }));
      if (value && index < 5) {
        const nextInput = document.getElementById(`otp-${index + 1}`);
        if (nextInput) nextInput.focus();
      }
    }
  };
  const [otpLoading, setOtpLoading] = useState(false);
  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    setOtpLoading(true);
    const otpString = phoneLogin.otp.join("");
    if (otpString.length !== 6 || !/^[0-9]{6}$/.test(otpString)) {
      showToast("Invalid OTP", "error");
      setOtpLoading(false);
      return;
    }

    if (!Confirmationresult) {
      showToast("No OTP session", "error");
      setOtpLoading(false);
      return;
    }

    try {
      await Confirmationresult.confirm(otpString);
      showToast("Welcome back!", "success");
      triggerLoginPopup(false);
      setOtpLoading(false);
    } catch (error) {
      console.error("OTP verification error:", error.code, error.message);
      let errorMessage = "Invalid or expired OTP. Please try again.";
      switch (error.code) {
        case "auth/invalid-verification-code":
          errorMessage = "Invalid OTP. Please check and try again.";
          break;
        case "auth/code-expired":
          errorMessage = "OTP expired. Please request a new one.";
          break;
        default:
          errorMessage = `Error: ${error.message}`;
      }
      setOtpLoading(false);
      showToast(errorMessage, "error");
    }
  };

  // ================================ Google Authentication =============================== //
  const authenticateUserGoogle = () => {
    signInWithPopup(auth, provider)
      .then(() => {
        triggerLoginPopup(false);
      })
      .catch((error) => {
        alert(error.message);
      });
  };

  // ================================ Email Authentication =============================== //
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (name === "password" || name === "confirmPassword") {
      if (name === "password") {
        if (formData.confirmPassword && value !== formData.confirmPassword) {
          setPasswordError("Passwords don't match!");
        } else if (
          formData.confirmPassword &&
          value === formData.confirmPassword
        ) {
          setPasswordError("");
        }
      } else if (name === "confirmPassword") {
        if (formData.password && value !== formData.password) {
          setPasswordError("Passwords don't match!");
        } else if (formData.password && value === formData.password) {
          setPasswordError("");
        }
      }
    }
  };

  // =============================== Mode Switch =============================== //
  const handleModeSwitch = () => {
    setIsSignUp(!isSignUp);
    setAuthMethod("email");
    setPasswordError("");
    setFormData({
      name: "",
      email: "",
      phone: "",
      password: "",
      confirmPassword: "",
      countryCode: "91",
    });
  };

  const showToast = (message, type) => {
    setToast({ show: true, message, type });
    setTimeout(
      () => setToast({ show: false, message: "", type: "success" }),
      3000
    );
  };

  const handleEmailSignUp = async(e) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      showToast("Passwords don't match!", "error");
      setPasswordError("Passwords don't match!");
      return;
    }
    if (formData.password.length < 6) {
      showToast("Password must be at least 6 characters long!", "error");
      return;
    }
    const functions = getFunctions(app, "asia-south1");
    const bristuEmailAuthCreate = httpsCallable(
      functions,
      "bristuEmailAuthCreate"
    );
    try {
      const result = await bristuEmailAuthCreate({ 
        mobile: formData.countryCode + formData.phone,
        email: formData.email,
        password: formData.password,
        name: formData.name,
      });
      if (result.data.code === 200) {
        handleAutoEmailSignIn(result.data.uid);
      } else if (result.data.code === 404) {
        showToast("Account does not exist. Please sign up using email", "error");
      } else {
        console.error("Error calling function:", result.data);
        showToast("Something went wrong. Please try again", "error");
      }
    } catch (err) {
      console.error("Error calling function:", err.message);
    }
    // setPasswordError("");
    // showToast("Account created successfully!", "success");
    // triggerLoginPopup(false);
  };
  const handleAutoEmailSignIn = () => {
    const auth = getAuth();
    signInWithEmailAndPassword(auth, formData.email, formData.password)
      .then(() => {
        window.location.reload();
      })
      .catch((error) => {
        // const errorCode = error.code;
        const errorMessage = error.message;
        showToast(errorMessage, "error");
      });
    showToast("Signed in successfully!", "success");
    triggerLoginPopup(false);
  };

  const handleEmailSignIn = (e) => {
    e.preventDefault();
    if (formData.password.length < 6) {
      showToast("Password must be at least 6 characters long!", "error");
      return;
    }
    const auth = getAuth();
    signInWithEmailAndPassword(auth, formData.email, formData.password)
      .then(() => {
        showToast("Signed in successfully!", "success");
        triggerLoginPopup(false);
      })
      .catch((error) => {
        const errorMessage = error.message;
        showToast(errorMessage, "error");
      });
  };

  return (
    <>
      {showLoginPopup && (
        <div
          className="fixed inset-0 px-4 bg-black/90 backdrop-blur-xl flex items-center justify-center z-50"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              triggerLoginPopup(false);
            }
          }}
        >
          <div className="bg-black border border-gray-700/50 shadow-2xl rounded-3xl w-full max-w-md overflow-hidden relative">
            <div className="absolute inset-0 bg-gradient-to-r from-emerald-500/5 to-blue-500/5 rounded-3xl"></div>

            <button
              onClick={() => triggerLoginPopup(false)}
              className="absolute top-3 right-3 p-2 text-gray-400 hover:text-white hover:bg-gray-800/50 rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-emerald-500 z-50"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            <div className="p-6 text-center relative z-10">
              <div className="relative">
                {!isSignUp && (
                  <img
                    src={logo}
                    alt="Company Logo"
                    className="mx-auto h-16 mb-4 drop-shadow-lg"
                  />
                )}
              </div>
              <h1 className="text-3xl font-bold bg-gradient-to-r from-gray-100 to-gray-300 bg-clip-text text-transparent mb-2">
                {isSignUp ? "Create Account" : "Welcome Back!"}
              </h1>
              <p className="text-gray-400 text-base leading-relaxed">
                {isSignUp
                  ? "Join us and start your journey today."
                  : "We're excited to see you again!"}
              </p>
            </div>

            <div className="px-5 pb-5 relative z-10">
              {/* Authentication Method Tabs */}
              <div className="flex mb-4 bg-gray-800/50 backdrop-blur-sm rounded-2xl p-1 border border-gray-700/50">
                <button
                  onClick={() => setAuthMethod("email")}
                  className={`flex-1 py-2.5 px-3 rounded-xl text-sm font-semibold transition-all duration-300 ${
                    authMethod === "email"
                      ? "bg-gradient-to-r from-emerald-600 to-emerald-700 text-white shadow-lg"
                      : "text-gray-400 hover:text-gray-200 hover:bg-gray-700/50"
                  }`}
                >
                  Email
                </button>
                <button
                  onClick={() => setAuthMethod("phone")}
                  className={`flex-1 py-2.5 px-3 rounded-xl text-sm font-semibold transition-all duration-300 ${
                    authMethod === "phone"
                      ? "bg-gradient-to-r from-emerald-600 to-emerald-700 text-white shadow-lg"
                      : "text-gray-400 hover:text-gray-200 hover:bg-gray-700/50"
                  }`}
                >
                  Phone
                </button>
              </div>

              {/* Email Authentication */}
              {authMethod === "email" && (
                <>
                  {/* Email/Password Form */}
                  <form
                    onSubmit={isSignUp ? handleEmailSignUp : handleEmailSignIn}
                    className="mb-4"
                  >
                    {isSignUp && (
                      <div className="mb-4 relative group">
                        <input
                          type="text"
                          name="name"
                          id="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          className="w-full px-4 py-3 bg-gray-800/50 backdrop-blur-sm border-2 border-gray-700/50 rounded-2xl text-gray-100 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/50 focus:border-emerald-500/50 transition-all duration-300 peer group-hover:border-gray-600/50"
                          placeholder="Full Name"
                          required
                        />
                      </div>
                    )}
                    <div className="mb-4 relative group">
                      <input
                        type="email"
                        name="email"
                        id="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 bg-gray-800/50 backdrop-blur-sm border-2 border-gray-700/50 rounded-2xl text-gray-100 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/50 focus:border-emerald-500/50 transition-all duration-300 peer group-hover:border-gray-600/50"
                        placeholder="Email address"
                        required
                      />
                    </div>

                    {isSignUp && (
                      <div className="mb-4 flex gap-2">
                        <div className="relative group flex-shrink-0">
                          <input
                            type="text"
                            name="countryCode"
                            id="countryCode"
                            value={formData.countryCode}
                            onChange={(e) => {
                              const value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              );
                              if (value.length <= 3) {
                                setFormData((prev) => ({
                                  ...prev,
                                  countryCode: value,
                                }));
                              }
                            }}
                            className="w-14 px-2 py-3 bg-gray-800/50 backdrop-blur-sm border-2 border-gray-700/50 rounded-2xl text-gray-100 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/50 focus:border-emerald-500/50 transition-all duration-300 text-center"
                            placeholder="91"
                            required
                          />
                        </div>
                        <div className="flex-1">
                          <input
                            type="tel"
                            name="phone"
                            id="phone"
                            value={formData.phone}
                            required
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 bg-gray-800/50 backdrop-blur-sm border-2 border-gray-700/50 rounded-2xl text-gray-100 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/50 focus:border-emerald-500/50 transition-all duration-300 peer group-hover:border-gray-600/50"
                            placeholder="Phone number"
                          />
                        </div>
                      </div>
                    )}

                    <div className="mb-4 relative group">
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        id="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        className={`w-full px-4 py-3 pr-12 bg-gray-800/50 backdrop-blur-sm border-2 rounded-2xl text-gray-100 placeholder-gray-400 focus:outline-none focus:ring-2 transition-all duration-300 peer group-hover:border-gray-600/50 ${
                          passwordError && formData.confirmPassword
                            ? "border-red-500/50 focus:ring-red-500/50 focus:border-red-500/50"
                            : "border-gray-700/50 focus:ring-emerald-500/50 focus:border-emerald-500/50"
                        }`}
                        placeholder="Password"
                        required
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-200 transition-colors duration-200"
                      >
                        {showPassword ? (
                          <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21"
                            />
                          </svg>
                        ) : (
                          <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                            />
                          </svg>
                        )}
                      </button>
                    </div>

                    {isSignUp && (
                      <div className="mb-4 relative group">
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          name="confirmPassword"
                          id="confirmPassword"
                          value={formData.confirmPassword}
                          onChange={handleInputChange}
                          className={`w-full px-4 py-3 pr-12 bg-gray-800/50 backdrop-blur-sm border-2 rounded-2xl text-gray-100 placeholder-gray-400 focus:outline-none focus:ring-2 transition-all duration-300 peer group-hover:border-gray-600/50 ${
                            passwordError && formData.password
                              ? "border-red-500/50 focus:ring-red-500/50 focus:border-red-500/50"
                              : "border-gray-700/50 focus:ring-emerald-500/50 focus:border-emerald-500/50"
                          }`}
                          placeholder="Confirm password"
                          required
                        />
                        <button
                          type="button"
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-200 transition-colors duration-200"
                        >
                          {showConfirmPassword ? (
                            <svg
                              className="w-5 h-5"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21"
                              />
                            </svg>
                          ) : (
                            <svg
                              className="w-5 h-5"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                              />
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                              />
                            </svg>
                          )}
                        </button>
                      </div>
                    )}

                    {/* Password Error Message */}
                    {passwordError && isSignUp && (
                      <div className="mb-4 p-3 bg-red-500/10 border border-red-500/20 rounded-xl">
                        <div className="flex items-center space-x-2">
                          <svg
                            className="w-5 h-5 text-red-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                          </svg>
                          <span className="text-red-400 text-sm font-medium">
                            {passwordError}
                          </span>
                        </div>
                      </div>
                    )}

                    <button
                      type="submit"
                      className="w-full bg-gradient-to-r from-emerald-600 to-emerald-700 hover:from-emerald-700 hover:to-emerald-800 text-white font-bold py-3 px-4 rounded-2xl transition-all duration-300 shadow-lg hover:shadow-emerald-500/25 transform hover:scale-[1.02] mb-4"
                    >
                      {isSignUp ? "Create Account" : "Sign In"}
                    </button>
                  </form>
                </>
              )}

              {/* Phone Authentication */}
              {authMethod === "phone" && (
                <div className="space-y-4">
                  {!phoneLogin.showOtp ? (
                    <form onSubmit={handleAuthAccountCheck} className="mb-4">
                      <div className="mb-4 relative group">
                        <div className="relative group flex-shrink-0 gap-2 flex items-center">
                          <select
                            value={phoneLogin.countryCode}
                            className="px-4 py-3 bg-gray-800/50 backdrop-blur-sm border-2 border-gray-700/50 rounded-2xl text-gray-100 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/50 focus:border-emerald-500/50 transition-all duration-300 peer group-hover:border-gray-600/50"
                            onChange={(e) =>
                              setPhoneLogin({
                                ...phoneLogin,
                                countryCode: e.target.value,
                              })
                            }
                          >
                            {countryCodes.map((country) => (
                              <option key={country.name} value={country.code}>
                                {country.code}
                              </option>
                            ))}
                          </select>
                          <input
                            type="tel"
                            value={phoneLogin.phone}
                            onChange={(e) =>
                              setPhoneLogin((prev) => ({
                                ...prev,
                                phone: e.target.value,
                              }))
                            }
                            className="w-full px-4 py-3 bg-gray-800/50 backdrop-blur-sm border-2 border-gray-700/50 rounded-2xl text-gray-100 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/50 focus:border-emerald-500/50 transition-all duration-300 peer group-hover:border-gray-600/50"
                            placeholder="Phone number"
                            required
                          />
                        </div>
                      </div>
                      {otpError && (
                        <div className="text-center text-red-500 mb-4">
                          <span>{otpError}</span>
                        </div>
                      )}
                      <button
                        disabled={phoneLoading}
                        type="submit"
                        className="w-full bg-gradient-to-r from-emerald-600 to-emerald-700 hover:from-emerald-700 hover:to-emerald-800 text-white font-bold py-3 px-4 rounded-2xl transition-all duration-300 shadow-lg hover:shadow-emerald-500/25 transform hover:scale-[1.02] mb-4"
                      >
                        {phoneLoading ? "Loading..." : "Send OTP"}
                      </button>
                    </form>
                  ) : (
                    <div className="space-y-4">
                      <div className="text-center mb-4">
                        <p className="text-gray-300 text-sm">
                          Enter the 6-digit code sent to{" "}
                          <span className="text-emerald-400 font-semibold">
                            {phoneLogin.phone}
                          </span>
                        </p>
                      </div>

                      <form onSubmit={handleOtpSubmit} className="space-y-4">
                        <div className="flex justify-center space-x-2 mb-4">
                          {phoneLogin.otp.map((digit, index) => (
                            <input
                              key={index}
                              id={`otp-${index}`}
                              type="text"
                              maxLength="1"
                              value={digit}
                              onChange={(e) =>
                                handleOtpChange(index, e.target.value)
                              }
                              className="w-12 h-12 text-center bg-gray-800/50 backdrop-blur-sm border-2 border-gray-700/50 rounded-xl text-gray-100 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/50 focus:border-emerald-500/50 transition-all duration-300"
                              placeholder=""
                            />
                          ))}
                        </div>

                        <div className="text-center mb-4">
                          <span className="text-gray-400 text-sm">
                            Didn't receive code?{" "}
                          </span>
                          <button
                            type="button"
                            onClick={handleResendOtp}
                            className={`text-emerald-400 hover:text-emerald-300 font-semibold ml-1 transition-colors duration-300 ${
                              resendTimer > 0
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                            disabled={resendTimer > 0}
                          >
                            {resendTimer > 0
                              ? `Resend in ${Math.floor(resendTimer / 60)
                                  .toString()
                                  .padStart(2, "0")}:${(resendTimer % 60)
                                  .toString()
                                  .padStart(2, "0")}`
                              : "Resend"}
                          </button>
                        </div>

                        <button
                          disabled={otpLoading}
                          type="submit"
                          className="w-full bg-gradient-to-r from-emerald-600 to-emerald-700 hover:from-emerald-700 hover:to-emerald-800 text-white font-bold py-3 px-4 rounded-2xl transition-all duration-300 shadow-lg hover:shadow-emerald-500/25 transform hover:scale-[1.02] flex items-center justify-center space-x-2"
                        >
                          <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                          </svg>
                          <span>{otpLoading ? "Loading..." : "Verify"}</span>
                        </button>
                      </form>
                    </div>
                  )}
                </div>
              )}

              {/* Divider */}
              <div className="flex items-center mb-4">
                <div className="flex-1 h-px bg-gradient-to-r from-transparent via-gray-600 to-transparent"></div>
                <span className="px-4 text-gray-500 text-sm font-medium">
                  or
                </span>
                <div className="flex-1 h-px bg-gradient-to-r from-transparent via-gray-600 to-transparent"></div>
              </div>

              {/* Google Sign In */}
              <button
                onClick={authenticateUserGoogle}
                className="w-full flex items-center justify-center bg-white border border-gray-300 rounded-2xl py-3 px-6 text-black hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-emerald-500/50 transition-all duration-300 shadow-lg hover:shadow-white/10 transform hover:scale-[1.02]"
              >
                <svg
                  className="w-6 h-6 mr-3"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 48 48"
                >
                  <path
                    fill="#FFC107"
                    d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12s5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24s8.955,20,20,20s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
                  />
                  <path
                    fill="#FF3D00"
                    d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
                  />
                  <path
                    fill="#4CAF50"
                    d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
                  />
                  <path
                    fill="#1976D2"
                    d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
                  />
                </svg>
                <span className="font-semibold">Sign in with Google</span>
              </button>
            </div>

            {/* Toggle between Login and Signup */}
            <div className="px-6 pb-6 text-center relative z-10">
              <p className="text-gray-400 text-sm">
                {isSignUp
                  ? "Already have an account?"
                  : "Don't have an account?"}{" "}
                <button
                  onClick={handleModeSwitch}
                  className="text-emerald-400 hover:text-emerald-300 font-semibold hover:underline transition-colors duration-300"
                >
                  {isSignUp ? "Sign In" : "Sign Up"}
                </button>
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Toast Notification */}
      {toast.show && (
        <div
          className={`fixed top-4 right-4 z-[9999] px-6 py-4 rounded-lg shadow-lg transform transition-all duration-300 ${
            toast.type === "error"
              ? "bg-red-500 text-white"
              : "bg-emerald-500 text-white"
          }`}
        >
          <div className="flex items-center space-x-2">
            {toast.type === "error" ? (
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            ) : (
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            )}
            <span className="font-medium">{toast.message}</span>
          </div>
        </div>
      )}
      <div
        id="recaptcha-container"
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          width: 0,
          height: 0,
          zIndex: -1,
        }}
      ></div>
    </>
  );
}
